import {
  EWorkZonesManagementRights,
} from "mhc-server/dist/interfaces";

import {IAppRoute} from "../../application/config/IAppRoute";
import {WorkzonesListPage} from "../pages/WorkzonesListPage/WorkzonesListPage";
import WorkzonesListIcon from "@mui/icons-material/ListAlt";

export const routeWorkZonesList: IAppRoute<{search?: string}> = {
  title: 'CIMs Management',
  description: 'Connected Infrastructure Messages',
  icon: <WorkzonesListIcon/>,
  routePath: '/cims/list/:search?/',
  getRoutePath: () => routeWorkZonesList.routePath,
  menuId: 'cims-list',
  userHasAllRights: [],
  userHasAnyOfRights: [
    EWorkZonesManagementRights.WORKZONES_VIEW,
    EWorkZonesManagementRights.WORKZONES_EDIT,
  ],
  render: ({pathParams: {search = ""}}) =>
    <WorkzonesListPage
      search={search}
    />,
};
